import { Box, useToast } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { QrReader } from "react-qr-reader";
import { useParams } from "react-router-dom";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { decrypt } from "../helpers/hash";
import Confirm from "./Confirm";
import EventCard from "./EventCard";

export default function Scanner() {
  const { id } = useParams();
  const toast = useToast();

  const [dataUser, setDataUser] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [event, setEvent] = useState({});

  useEffect(() => {
    baseService.get(
      config.services.event.getEventById + id,
      (res) => {
        setEvent(res.data);
      },
      (err) => console.log(err)
    );
    localStorage.removeItem("user_exist");
  }, [id]);

  function checkUserRegistration(result) {
    if (result.eventId !== id) {
      return setOpenModal(!openModal);
    }
    if (localStorage.getItem("user_exist")) return;

    checkEvent(result);
  }
  function checkEvent(payload) {
    baseService.post(
      config.services.event.scanQR,
      payload,
      (res) => {
        setDataUser(res.data);
        localStorage.setItem("user_exist", true);
        setOpenModal(!openModal);
      },
      (err) => console.log(err)
    );
  }

  function setAttendance() {
    baseService.patch(
      config.services.event.changeAttendance,
      { eventId: dataUser.eventId, phoneNumber: dataUser.phoneNumber },
      (res) => {
        toast({
          position: "top",
          description: res.data.message,
          status: "success",
          duration: 1500,
          size: "sm",
          isClosable: true,
        });
      },
      (err) => console.log(err)
    );

    localStorage.removeItem("user_exist");
    setDataUser({});
    setOpenModal(!openModal);
  }

  return (
    <div>
      <EventCard data={event} />
      <Box className="scanner-box">
        <div
          className={
            Object.keys(dataUser).length > 0
              ? "corner-border-success"
              : "corner-border"
          }
        />
        <QrReader
          constraints={{
            facingMode: "environment",
          }}
          onResult={(result, error) => {
            if (!!result) {
              checkUserRegistration(JSON.parse(decrypt(result?.text)));
            }
          }}
          style={{ width: "100%" }}
        />
      </Box>
      <Confirm
        content={{
          title:
            Object.keys(dataUser).length > 0 ? "Konfirmasi Kehadiran" : "Gagal",
          desc:
            Object.keys(dataUser).length > 0
              ? `Nama: ${dataUser.name} 
No. HP: ${dataUser.phoneNumber}
Gender: ${dataUser.gender}
Asal: ${dataUser.origin || "-"}
`
              : `User tidak terdaftar dalam event ${event.eventName}`,
        }}
        active={openModal}
        onCancel={() => {
          setDataUser({});
          setOpenModal(!openModal);
          localStorage.removeItem("user_exist");
        }}
        cancelButton={Object.keys(dataUser).length > 0 ? true : false}
        callback={() =>
          Object.keys(dataUser).length > 0
            ? setAttendance()
            : setOpenModal(!openModal)
        }
      />
    </div>
  );
}
